
import Vue from 'vue'

export default Vue.extend({
  props: {
    currency: {
      type: Object,
      required: true
    }
  },
  methods: {
    defineCurrencyChangeSign (curr: number, prev: number) {
      switch (Math.sign(curr - prev)) {
        case 1:
          return '#icon-balance-up'
        case -1:
          return '#icon-balance-down'
        default:
          return ''
      }
    }
  }
})
